module.exports = __webpack_public_path__ + "static/media/VHST06.b49dccac.jpg";